import { useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form } from "react-final-form";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../../util/api";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { OnshoreConfigurationForm } from "./OnshoreConfigurationForm";

export const EditOnshoreConfigurationModal = ({ onshoreConfiguration, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const initialValues = {
    lab_id: onshoreConfiguration.lab?.id,
    clinic_id: onshoreConfiguration.clinic?.id,
    payor_id: onshoreConfiguration.payor?.id,
    test_id: onshoreConfiguration.test?.id,
    cpt_code_ids: onshoreConfiguration.cptCodes.map((code) => code.id),
    classification: onshoreConfiguration.classification,
  };

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    try {
      const res = await api.patch(`/admin/onshore_configurations/${onshoreConfiguration.id}`, {
        onshore_configuration: snakifyKeys(params),
      });

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal size="lg" isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Onshore Configuration {onshoreConfiguration.id}</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={camelizeKeys({ ...onshoreConfiguration, ...initialValues })}>
            {(props) => <OnshoreConfigurationForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
